import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

export const useStyles = makeStyles(() =>
  /* Styles applied to the input element. */
  ({
    title: {
      '& .MuiTypography-h6': {
        fontSize: 16,
        fontWeight: 600,
      },
    },
    boldText: {
      fontWeight: 600,
    },
  }),
);

const ErrorModal = ({ show, errorMessage }) => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(show);
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t('error_modal_description', `${errorMessage}`)}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            {t('ok_text', 'OK')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

ErrorModal.propTypes = {
  show: PropTypes.bool,
  errorMessage: PropTypes.string,
};

export default ErrorModal;
